import {
  makeRequired, stringValidator,
} from '../../../../../OUI/Inputs';

export const recaptchaValidator = makeRequired(stringValidator);
